import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Input,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const ModTreatmentItemsUX = (props: any) => {
    return(
      <div
        id="ModTreatmentItemsUX-div-0">
        <Segment
          id="ModTreatmentItemsUX-Segment-1">
          <div
            id="ModTreatmentItemsUX-div-2"
            style={{fontWeight: "bold", marginBottom: "8px"}}>
            ค้นหารายการหัตถการ
          </div>
          <hr
            id="ModTreatmentItemsUX-hr-3">
          </hr>
          <div
            id="ModTreatmentItemsUX-div-4"
            style={{display: "flex", alignItems: "center", marginTop: "12px"}}>
            
            <div
              id="ModTreatmentItemsUX-div-5">
              ชื่อหรือรหัส
            </div>
            <Input
              id="ModTreatmentItemsUX-Input-6"
              onChange={props.onChangeSearchQuery}
              style={{marginLeft: "16px", height: "32px", width: "75%"}}
              value={props.searchQuery}>
            </Input>
            <Button
              color="blue"
              id="ModTreatmentItemsUX-Button-7"
              onClick={props.onClickFilterTreatmentItems}
              style={{marginLeft: "16px", width: "100px", height: "32px", lineHeight: "0px"}}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <div
            id="ModTreatmentItemsUX-div-8"
            style={{marginTop: "24px", marginBottom: "24px"}}>
            
            <Table
              data={props.treatmentItemsList}
              defaultPageSize={19}
              getTdProps={props.getTdProps}
              getTrProps={props.getTrProps}
              headers=",รหัสหัตถการ,ชื่อหัตถการ,ราคา"
              id="ModTreatmentItemsUX-Table-13"
              keys="selectedItem,item_code,item_name,item_price"
              minRows={19}
              onPageChange={props.onPageChange}
              page={props.page}
              pages={props.pages}
              showPageSizeOptions={false}
              showPagination={false}
              widths="40,120,588,120">
            </Table>
          </div>
          <div
            id="ModTreatmentItemsUX-div-10"
            style={{display: "flex", justifyContent: "flex-end"}}>
            
            <Button
              color="green"
              id="ModTreatmentItemsUX-Button-11"
              onClick={props.addTreatments}
              style={{width: "120px", marginRight: "24px"}}>
              เลือก
            </Button>
            <Button
              color="red"
              id="ModTreatmentItemsUX-Button-12"
              onClick={props.onClickCancel}
              style={{width: "120px"}}>
              ยกเลิก
            </Button>
          </div>
        </Segment>
      </div>
    )
}


export default ModTreatmentItemsUX

export const screenPropsDefault = {}

/* Date Time : Fri Sep 12 2025 17:10:27 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-0"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหารายการหัตถการ"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginBottom: \"8px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-hr-3"
        }
      },
      "seq": 3,
      "void": true
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginTop: \"12px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหรือรหัส"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Input",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Input-6"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchQuery"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"16px\", height: \"32px\", width: \"75%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchQuery"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickFilterTreatmentItems"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"16px\", width: \"100px\", height: \"32px\", lineHeight: \"0px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"24px\", marginBottom: \"24px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "props.addTreatments"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"120px\", marginRight: \"24px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Button-12"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        },
        "style": {
          "type": "code",
          "value": "{width: \"120px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 13,
      "name": "Table",
      "parent": 8,
      "props": {
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.treatmentItemsList"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "19"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": ",รหัสหัตถการ,ชื่อหัตถการ,ราคา"
        },
        "id": {
          "type": "value",
          "value": "ModTreatmentItemsUX-Table-13"
        },
        "keys": {
          "type": "value",
          "value": "selectedItem,item_code,item_name,item_price"
        },
        "minRows": {
          "type": "code",
          "value": "19"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "page": {
          "type": "code",
          "value": "props.page"
        },
        "pageSize": {
          "type": "code",
          "value": ""
        },
        "pages": {
          "type": "code",
          "value": "props.pages"
        },
        "showPageSizeOptions": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "40,120,588,120"
        }
      },
      "seq": 13,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "ModTreatmentItemsUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 70
}

*********************************************************************************** */
